export default "../images/stackloans-partners-with-Payoff_PORTAL_US.png?4b954dd9e4f7f17e12bb15d23beac29b";